import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Copyright */}
          <div className="text-sm text-gray-600">
            © {currentYear} ivoliq.io
          </div>

          {/* Links */}
          <div className="flex gap-6 text-sm">
            <Link 
              to="/impressum" 
              className="text-gray-600 hover:text-blue-600 transition-colors"
            >
              {t('footer.impressum', 'Impressum')}
            </Link>
            <Link 
              to="/privacy" 
              className="text-gray-600 hover:text-blue-600 transition-colors"
            >
              {t('footer.privacy', 'Datenschutz')}
            </Link>
            <Link 
              to="/terms" 
              className="text-gray-600 hover:text-blue-600 transition-colors"
            >
              {t('footer.terms', 'AGB')}
            </Link>
            <button
              onClick={() => {
                // Clear consent cookie to show banner again
                document.cookie = 'ivoliq_cookie_consent=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
                window.location.reload();
              }}
              className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
            >
              {t('footer.cookieSettings', 'Cookie-Einstellungen')}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
